import { setNewRelicCustomAttribute } from "./newrelic";
import clientSide from "./clientSide";

/**
 * Get blocked sessions flag from window._Monarch
 */
export function getMonarchIsBlocked(): boolean {
  if (!clientSide || !window._Monarch) {
    return false;
  }

  return window._Monarch?.evaluations?.source?.source?.blockedSessions?.value ?? false;
}

/**
 * Comprehensive check if a session should be blocked
 * Reads from window._Monarch directly
 * Logs and tracks blocked sessions in New Relic
 */
export function checkSessionBlocked(sessionId: string | undefined): boolean {
  // Check Monarch rule
  if (getMonarchIsBlocked()) {
    console.log(`Session blocked: ${sessionId}, reason: monarch_rule`);
    setNewRelicCustomAttribute([
      { name: "blockedSessionCart", value: sessionId || "unknown" },
      { name: "blockReasonCart", value: "monarch_rule" },
    ]);
    return true;
  }

  return false;
}
